import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const newsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // list
    getNewsList: builder.query<
      any,
      { search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ search, page, deleted }) => ({
        url: "news/list",
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
      providesTags: ["News"],
    }),

    // show
    showNews: builder.query<any, number>({
      query: (id) => ({
        url: `news/show/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
      providesTags: ["News"],
    }),

    // store
    storeNews: builder.mutation<IApiResponse<any>, object>({
      query: (data) => ({
        url: "news",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => (result ? [{ type: "News" }] : []),
    }),

    // update
    updateNews: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `news/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "News" }] : []),
    }),

    // delete
    deleteNews: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `news/${id}`,
        method: "POST",
        body: { _method: "DELETE" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "News" }] : []),
    }),

    // status
    changeNewsStatus: builder.mutation<
      IApiResponse<any>,
      { id: number; status: string }
    >({
      query: ({ id, status }) => ({
        url: `news/change-status/${id}`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: (result) => (result ? [{ type: "News" }] : []),
    }),

    // pending
    unpublishedNewsStatus: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `news/change-status-to-unpublished/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "News" }] : []),
    }),
  }),
});

export const {
  useGetNewsListQuery,
  useShowNewsQuery,
  useStoreNewsMutation,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
  useChangeNewsStatusMutation,
  useUnpublishedNewsStatusMutation,
} = newsApi;

export default newsApi;
